import React from 'react';
import { useSelector } from 'react-redux';
import { Typography } from 'fronton-react';
import { getPriceText } from 'utils';
import { selectRoughWorkConfigurators } from '../../../selectors';
import { galleryStyles, PicContainer } from './styles';

export const Gallery = () => {
	const configurators = useSelector(selectRoughWorkConfigurators);

	return (
		<div className={galleryStyles}>
			{configurators.map((el, index) => (
				<div className="wrapper" style={{ gridArea: 'item' + (index + 1) }} key={el.name}>
					<PicContainer imageUrl={el.imageUrl}>
						<div className="price">
							от {getPriceText(el.price)} <span> ₽/{el.measurementUnit}</span>
						</div>
					</PicContainer>
					<Typography className="name" variant="l" size="subtitle">
						{el.name}
					</Typography>
				</div>
			))}
		</div>
	);
};
